<script>
    import axios from 'axios';
    import {URLS} from '@/services/Constants';
    import GroupService from '@/services/GroupService';
    import SorterService from '@/services/SorterService';
    import NavigationHeader from '../NavigationHeader.vue';
    import ButtonIconLeft from '../buttons/ButtonIconLeft.vue';
    import GroupTile from './GroupTile';
    import HotlineTile from './HotlineTile';
    import Badge from '../shared/Badge';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'GroupsOverview',
        components: {
            NavigationHeader,
            ButtonIconLeft,
            GroupTile,
            HotlineTile,
            Badge
        },
        data() {
            return {
                groupList: [],
                phoneNumberList: [],
                noGroupsAvailable: true,
                hotline: {},
                showHotlineTile: false
            };
        },
        computed: {
            ...mapGetters({
                isHotlineCreated: 'isHotlineCreated',
                isPremium: 'isPremium'
            })
        },
        created() {
            GroupService.getAllGroups()
                .then((responseGetAllGroups) => {
                    this.groupList = responseGetAllGroups.data;
                    if (this.groupList.length > 0) {
                        this.noGroupsAvailable = false;
                        SorterService._sortArrayOfStringsByParam(this.groupList, 'groupname');
                    }
                });
            this.getHotlineIVR().then( response => {
                if (this.isHotlineCreated) {
                    this.hotline = response;
                    this.showHotlineTile = true;
                }
            });
        },
        methods: {
            ...mapActions(['getHotlineIVR']),
        }
    };
</script>

<template>
    <div class="container">
        <div id="groups-hotlines">
            <NavigationHeader route="/" navigationText="zurück zum Dashboard" title="Gruppen & Hotline"/>
            <template>
                <div class="intro">
                    <div class="header">
                        <span class="title">Gruppen</span>
                    </div>
                    <div class="description">
                        Füge mehrere Benutzer zu einer Gruppe hinzu und lege eine spezifische Gruppenrufnummer fest. Alle Gruppenmitglieder sind unter dieser Nummer erreichbar. 
                    </div>
                    <div class="action">
                    <ButtonIconLeft @onClick="$router.push('/groups/newGroup')" class="btn-create"
                                    buttonTitle="Gruppe hinzufügen" src="add" cssClass="btn btn-primary"/>
                    </div>
                </div>

                <div class="tiles">
                    <div class="wrapper">
                        <GroupTile :style="{msGridColumn: (2 * index + 1) % 6, msGridRow: Math.floor(index / 3) + 1}" v-for="(entry, index) in groupList" :key="entry.id" :groupId="entry.id"/>
                    </div>
                </div>
            </template>
            <div class="blocks-padding"></div>
            <template>
                <div class="intro">
                    <div class="header">
                        <span class="title">Hotline mit Sprachmenü</span>
                        <Badge v-if="!isPremium" title="UP-Grade"/>
                        <router-link v-if="!isPremium" class="tariff-link" :to="'/tariff'">
                            <span>zum STARFACE-UP Tarif wechseln</span>
                        </router-link>
                    </div>
                    <div :class="{disabled: !isPremium}" class="description">
                        Lege eine Rufnummer für Deine Hotline fest und konfiguriere ein Sprachdialogsystem für eingehende Anrufe (IVR einstufig).
                    </div>
                    <div class="action">
                    <ButtonIconLeft @onClick="$router.push('/groups/hotline')" class="btn-create"
                                    buttonTitle="Hotline hinzufügen" src="add" cssClass="btn btn-primary" :disabled="isHotlineCreated || !isPremium"/>
                    </div>
                </div>

                <div class="tiles">
                    <div class="wrapper">
                        <HotlineTile v-if="showHotlineTile" :hotlineData="hotline"/>
                    </div>
                </div>
            </template>

        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../assets/scss/variables.scss';
    @import '../../assets/scss/grid.scss';

    #groups-hotlines {
        .intro {
            .header {
                display: flex;
                padding-bottom: 16px;
                align-items: center;
                .title {
                    font-size: 18px;
                    font-size: 28px;
                    letter-spacing: 0;
                    line-height: 35px;
                    color: $grey-dark;
                    padding-right: 8px;
                }
                .tariff-link {
                    color:$orange;
                    margin-left: auto;
                }
            }

            .description {
                width: 100%;
                margin: 0 auto;
                padding-bottom: 24px;
                &.disabled {
                    opacity: .4;
                }
            }
            .action {
                display: flex;
                justify-content: flex-end;
                .btn:disabled {
                    opacity: 1;
                    background: $grey-light;
                    border: $grey-light;
                }
            }
        }
        .tiles {
            display: grid;
            display: -ms-grid;
            grid-template-columns: 1fr;
            -ms-grid-columns: 1fr;
            .right {
                @extend .grid-row-1;
                justify-self: end;
                -ms-grid-column-align: end;
            }
            .wrapper {
                @extend .grid-row-2;
                display: grid;
                display: -ms-grid;
                grid-template-columns: 1fr 1fr 1fr;
                -ms-grid-columns: 1fr 24px 1fr 24px 1fr;
                grid-column-gap: 24px;
                margin-top: 8px;
            }
        }
        .blocks-padding {
            display:block;
            padding-top: 48px;
        }
    }
</style>
